import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class AuthenticationService {
    endpoint: any = environment.endpoint;
    httpClient: any;

    constructor(private http: HttpClient) {}

    login(credentials: any): Observable<any> {
        return this.http
            .post(this.endpoint + "patient/login", credentials)
            .pipe(
                map((data: any) => {
                    return data;
                }),
            );
    }

    logout(token: any): Observable<any> {
        return this.http.post(this.endpoint + "patient/logout", token).pipe(
            map((data: any) => {
                return data;
            }),
        );
    }

    contact(contact: any): Observable<boolean> {
        const t = this;

        return this.http
            .post(t.endpoint + "contact", contact)
            .pipe(map((res: any) => res || []));
    }

    sendForgotPasswordEmail(email: string) {
        return this.http.post("/api/auth/forgot-password", { email });
    }
}
